export default __webpack_public_path__ + "static/media/0xee9801669c6138e84bd50deb500827b776777d28.aafd8c52.webp";